import { useMemo } from 'react';
import moment from 'moment';


export const useApiBaseUrl = (appUrl) => {
  const apiBaseUrl = useMemo(() => {
    const appName = localStorage.getItem("appName");
    const network = localStorage.getItem("network");
    const collabType = localStorage.getItem("collabType");
    const roleName = localStorage.getItem("roleName");

    if (appName && network && collabType && roleName) {
      return `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
    }
    return null;
  }, [
    appUrl,
    localStorage.getItem("appName"),
    localStorage.getItem("network"),
    localStorage.getItem("collabType"),
    localStorage.getItem("roleName"),
  ]);

  return apiBaseUrl;
};


export const getApiBaseUrl = (appUrl) => {
  const appName = localStorage.getItem("appName");
  const network = localStorage.getItem("network");
  const collabType = localStorage.getItem("collabType");
  const roleName = localStorage.getItem("roleName");

  if (appName && network && collabType && roleName) {
    return `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
  }
  return null;
};


// Format an ISO / timestamp value (e.g. "2026-05-21T18:30:00.000Z") as the
// "22-MAY-2026" style used across the dashboard. Non-date / empty values pass
// through unchanged so we never render "Invalid date".
//
// Deliberately viewer-local (moment parses the instant and formats in the
// browser's timezone), matching every other date render in the app — no
// timezone is pinned anywhere in this codebase. Callers must pass the full
// timestamp: a pre-truncated "YYYY-MM-DD" string parses as local midnight, so
// any UTC-vs-local day shift is already baked in and cannot be corrected here.
export const formatDisplayDate = (value) => {
  if (value === undefined || value === null || value === "") return "";
  const m = moment(value);
  return m.isValid() ? m.format("DD-MMM-YYYY").toUpperCase() : value;
};


// Default export for backward compatibility
export default {
  useApiBaseUrl,
  getApiBaseUrl,
  formatDisplayDate
};